module.exports = __webpack_public_path__ + "static/img/back.51343cfc.png";